<template>
  <div class="event-calendar event-sidebar-section">
    <flat-pickr
      ref="calendar"
      v-model="date"
      :config="config"
      :events="events"
      @on-change="handleDateSelect"
      @on-day-create="handleDayCreate"
      @on-month-change="handleMonthChange"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: 'Calendar',

  components: {
    flatPickr
  },

  data () {
    return {
      date: null,
      enabledDates: [],
      config: {
        wrap: false,
        inline: true,
        clickOpens: false,
        static: true,
        dateFormat: 'Y-m-d',
        monthSelectorType: 'static',
      },
      events: [
        'onChange',
        'onMonthChange',
        'onDayCreate',
        'onReady'
      ],
      monthDatesLoaded: false
    }
  },

  created () {
    this.enabledDates = this.activeDates
    this.date = this.selectedDate
  },

  watch: {
    enabledDates: function (dates) {
      this.$refs.calendar.fp.set('enable', dates)
    },

    selectedDate: function (date) {
      this.date = date
    }
  },

  computed: {
    ...mapState([
      'assets',
      'activeDates',
      'selectedDate'
    ])
  },

  methods: {
    ...mapMutations([
      'loadMonthDates',
      'setSelectedDate'
    ]),

    handleDateSelect(dObj, dStr) {
      this.setSelectedDate(dStr)
    },

    handleDayCreate(dObj, dStr, fp, dayElem) {
      const formattedDate = fp.formatDate(dayElem.dateObj, 'Y-m-d')

      if (this.enabledDates.indexOf(formattedDate) === -1) {
        dayElem.classList.add('flatpickr-disabled')
      }
    },

    handleMonthChange(dateObj, dateStr, fp) {
      const newMonth = new Date
      newMonth.setFullYear(fp.currentYear)
      newMonth.setMonth(fp.currentMonth, 1)

      const endpoint = window._eventsApiEndpoint.split('?')[0] + '/updateMonth'

      $.ajax(endpoint + `?month=${fp.formatDate(newMonth, 'Y-m-d')}`)
        .then(resp => {
          const enabledDates = [...this.enabledDates].concat(resp.activeDates)

          this.enabledDates = enabledDates.filter((value, index, arr) => arr.indexOf(value) === index)
        })
    }
  }
}
</script>
